import axios from 'axios'
import apiLinks from '../../constant/api.links'
import {BASE_URL} from '../../api'
import API_LINKS from '../../constant/api.links'

const useBookings = () => {
  const getBookings = async (page: number, limit: number, searchString: string) => {
    try {
      console.log(process.env.REACT_APP_BACKEND_API_URL, 'ENV')
      const API_URL = BASE_URL + API_LINKS.GET_BOOKINGS + '?page=1&limit=10&searchString=' // 'http://localhost:8080/booking/bookings?page=1&limit=10&searchString='

      console.log('API URL: ', API_URL)
      const {data, status, statusText} = await axios.get(API_URL)

      return {data, status, statusText}
    } catch (error: any) {
      console.log(error, 'err')
      throw new Error(error)
    }
  }

  const getBooking = async (id: any) => {
    try {
      const API_URL = BASE_URL + API_LINKS.GET_BOOKING + '/' + id
      const {data, status} = await axios.get(API_URL)
      return {data, status}
    } catch (error: any) {
      throw new Error(error.message)
    }
  }

  const downloadAllBookings = async () => {
    try {
      const API_URL = BASE_URL + API_LINKS.DOWNLOAD_BOOKINGS
      const {data, status} = await axios.get(API_URL)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const getBookingFees = async (
    page: number,
    limit: number,
    searchString: string,
    type: string,
    startDate: string,
    endDate: string
  ) => {
    try {
      const url =
        BASE_URL +
        API_LINKS.GET_BOOKING_FEE +
        `?page=${page}&limit=${limit}&searchString=${searchString}&type=${type}&startDate=${startDate}&endDate=${endDate}`

      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const getCategories = async () => {
    try {
      const url = BASE_URL + API_LINKS.GET_CATEGORIES
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  // payload can include: scope, category, practitioner, listingType,
  // listing, value, type, startDate, endDate, active, note
  const addBookingFee = async (payload: Record<string, any>) => {
    try {
      const url = BASE_URL + API_LINKS.ADD_BOOKING_FEE
      const {data, status} = await axios.post(url, payload)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const updateBookingFee = async (id: string, payload: Record<string, any>) => {
    try {
      const url = BASE_URL + API_LINKS.UPDATE_BOOKING_FEE
      const {data, status} = await axios.put(url, {id, ...payload})
      return {data, status}
    } catch (error: any) {
      console.log(error, 'error-here')
      throw new Error(error)
    }
  }

  // Typeahead search helpers for the Booking Fees admin page's
  // practitioner/listing pickers.
  const searchPractitioners = async (search: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_USERS + `?page=1&limit=20&search=${encodeURIComponent(search)}`
      const {data} = await axios.get(url)
      return data?.docs || []
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const searchClasses = async (search: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_CLASS + `?page=1&limit=20&query=${encodeURIComponent(search)}`
      const {data} = await axios.get(url)
      return data?.docs || []
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const searchServices = async (search: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_ADMIN_SERVICES + `?page=1&limit=20&search=${encodeURIComponent(search)}`
      const {data} = await axios.get(url)
      return data?.docs || []
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const getBookingFeeById = async (id: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_BOOKING_FEE + '/' + id
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }
  return {
    getBookings,
    getBooking,
    getBookingFees,
    getCategories,
    addBookingFee,
    updateBookingFee,
    getBookingFeeById,
    downloadAllBookings,
    searchPractitioners,
    searchClasses,
    searchServices,
  }
}

export default useBookings
